<div class="badge">{{ item?.quantity || 0 }}X</div>
<div class="type">
    <i class="fa" [ngClass]="resolveMaterialTypeIcon(item?.material?.type)"></i>
    <span>{{ resolveMaterialTypeName(item?.material?.type) }}</span>
</div>
<div class="material">{{ item?.material?.name || 'Unassigned material' }}</div>
<a class="material-action waves-effect btn-flat"
   (click)="onOpenMaterial($event)">
    <i class="material-icons">open_in_new</i>
</a>
